const publications = [];

const viewStates = [
	'central',
	'dissertations',
	'chronological',
	'search',
	'alphabetical',
];

const defaultViewState = 'chronological';

function initPublications() {
	const searchInput = document.querySelector(
		'.publications-menu__search__input',
	);

	const url = new URL(window.location.href);

	const initialViewState = url.searchParams.get('view');
	const searchTerm = url.searchParams.get('keyword');

	if (
		initialViewState !== defaultViewState &&
		viewStates.includes(initialViewState)
	) {
		document.querySelector('.publications-archive').dataset.state =
			initialViewState;
	}

	const hasHashOnly = !initialViewState && window.location.hash;
	if (hasHashOnly) {
		document.querySelector('.publications-archive').dataset.state =
			'alphabetical';
	}

	const publicationsNodes = document.querySelectorAll(
		'.chronological .publication',
	);

	for (const publicationNode of publicationsNodes) {
		const publication = {
			id: parseInt(publicationNode.dataset.id),
			title: publicationNode.querySelector('.publication__heading').innerText,
			authors: publicationNode.querySelector('.publication__authors').innerText,
			source:
				publicationNode.querySelector('.publication__source')?.innerText || '',
			link:
				publicationNode.querySelector('.publication__link')?.innerText || '',
			node: publicationNode,
		};

		publications.push(publication);
	}

	for (const button of document.querySelectorAll(
		'.publications-menu__button',
	)) {
		button.addEventListener('click', (e) => {
			const state = e.currentTarget.dataset.setState;
			if (document.startViewTransition) {
				document.startViewTransition(() => {
					document.querySelector('.publications-archive').dataset.state = state;
				});
			} else {
				document.querySelector('.publications-archive').dataset.state = state;
			}

			updateSearchParams(state);
		});
	}

	document
		.querySelector('.publications-menu__button--search')
		.addEventListener('click', () => {
			document.querySelector('.publications-menu__search__input').focus();
		});

	searchInput.addEventListener('input', (e) => {
		const term = e.currentTarget.value;
		searchPublications(term);
	});

	if (initialViewState === 'search' && searchTerm) {
		searchInput.value = searchTerm;
		searchPublications(searchTerm);
	}

	// Browsers without JS get only the chronological view
	document.querySelector('.publications-menu').hidden = false;

	const hashString = window.location.hash;
	if (hashString) {
		const hashTarget = document.querySelector(hashString);

		if (hashTarget instanceof HTMLElement) {
			window.setTimeout(() => {
				hashTarget.scrollIntoView();
			}, 100);
		}
	}
}

window.addEventListener('DOMContentLoaded', initPublications);

function updateSearchParams(state, keyword = '') {
	const url = new URL(window.location.href);

	url.searchParams.delete('view');
	url.searchParams.delete('keyword');

	if (state !== defaultViewState && viewStates.includes(state)) {
		url.searchParams.set('view', state);
	}

	if (keyword) {
		url.searchParams.set('keyword', keyword);
	}

	window.history.replaceState(
		null,
		'',
		url.origin + url.pathname + url.search, // Exclude hash part of URL
	);
}

function searchPublications(term) {
	const termRegex = new RegExp(term, 'i');

	const results = publications.filter(({ title, authors, source, link }) => {
		return (
			termRegex.test(title) ||
			termRegex.test(authors) ||
			termRegex.test(source) ||
			termRegex.test(link)
		);
	});
	updateSearchParams('search', term);
	displaySearchResults(results, term);
}

function displaySearchResults(results, term) {
	const { fszPublicationsStrings } = window;
	const entriesContainer = document.querySelector(
		'.search-results .publications__entries',
	);

	document.querySelector('.search-results__term').innerText = term;
	const resultsInfo = document.querySelector('.search-results__count');
	if (!term.length) {
		resultsInfo.innerText = fszPublicationsStrings.keywordSearch;
		entriesContainer.innerHTML = '';
		return;
	}

	switch (results.length) {
		case 0: {
			resultsInfo.innerHTML = fszPublicationsStrings.none;
			break;
		}
		case 1: {
			resultsInfo.innerHTML = fszPublicationsStrings.one;
			break;
		}
		default: {
			resultsInfo.innerHTML = `${results.length} ${fszPublicationsStrings.multiple}`;
		}
	}

	const tempContainer = document.createElement('div');

	for (const publication of results) {
		tempContainer.insertAdjacentElement(
			'beforeend',
			publication.node.cloneNode(true),
		);
	}

	entriesContainer.innerHTML = tempContainer.innerHTML;
}
